module.exports = __webpack_public_path__ + "img/commerce1.7a1634fe.png";